'use client';

import { useNotificationCount } from '@lib/hooks/use-notification-count';
import { DashboardCard } from '@tuic/web-compositions/shared/DashboardCard';

import type { DashboardCardProps } from '@tuic/web-compositions/shared/DashboardCard';
import type { FC } from 'react';

type Props = {
  mxp365Token: string | undefined;
  variant?: 'chat' | 'messages';
  dashboardCard?: DashboardCardProps;
};

export const ChatCard: FC<Props> = ({
  mxp365Token,
  variant = 'chat',
  dashboardCard,
}) => {
  const { notifications = 0, chatMessages = 0 } = useNotificationCount({
    token: mxp365Token,
  });

  const badge = variant === 'messages' ? notifications : chatMessages;

  return (
    <DashboardCard {...dashboardCard} badge={badge < 1 ? undefined : badge} />
  );
};
